import * as Types from '../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPantherAIEnabledVariables = Types.Exact<{ [key: string]: never }>;

export type GetPantherAIEnabled = Pick<Types.Query, 'pantherAIEnabled'>;

export const GetPantherAIEnabledDocument = gql`
  query GetPantherAIEnabled {
    pantherAIEnabled
  }
`;

/**
 * __useGetPantherAIEnabled__
 *
 * To run a query within a React component, call `useGetPantherAIEnabled` and pass it any options that fit your needs.
 * When your component renders, `useGetPantherAIEnabled` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPantherAIEnabled({
 *   variables: {
 *   },
 * });
 */
export function useGetPantherAIEnabled(
  baseOptions?: Apollo.QueryHookOptions<GetPantherAIEnabled, GetPantherAIEnabledVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPantherAIEnabled, GetPantherAIEnabledVariables>(
    GetPantherAIEnabledDocument,
    options,
  );
}
export function useGetPantherAIEnabledLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPantherAIEnabled, GetPantherAIEnabledVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPantherAIEnabled, GetPantherAIEnabledVariables>(
    GetPantherAIEnabledDocument,
    options,
  );
}
export function useGetPantherAIEnabledSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetPantherAIEnabled, GetPantherAIEnabledVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPantherAIEnabled, GetPantherAIEnabledVariables>(
    GetPantherAIEnabledDocument,
    options,
  );
}
export type GetPantherAIEnabledHookResult = ReturnType<typeof useGetPantherAIEnabled>;
export type GetPantherAIEnabledLazyQueryHookResult = ReturnType<
  typeof useGetPantherAIEnabledLazyQuery
>;
export type GetPantherAIEnabledSuspenseQueryHookResult = ReturnType<
  typeof useGetPantherAIEnabledSuspenseQuery
>;
export type GetPantherAIEnabledQueryResult = Apollo.QueryResult<
  GetPantherAIEnabled,
  GetPantherAIEnabledVariables
>;
export function mockGetPantherAIEnabled({
  data,
  variables,
  errors,
}: {
  data: GetPantherAIEnabled;
  variables?: GetPantherAIEnabledVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetPantherAIEnabledDocument, variables },
    result: { data, errors },
  };
}
